﻿(function (document) {
    document.addEventListener('DOMContentLoaded', function (e) {
        document.querySelectorAll('.form-control [data-button]').forEach(function (element, index) {
            element.addEventListener('click', function (e) {
                var $button = document.querySelector(element.dataset.button);
                if ($button != null) {
                    $button.click();
                }
            });
        });
    });
})(document);